import * as React from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

export const Route = createFileRoute('/_authenticated/settings_/locations/$locationId/timeslots')({
  component: LocationTimeslotsPlaceholder,
  staticData: { titleKey: 'timeslots' },
});

function LocationTimeslotsPlaceholder(): React.JSX.Element {
  const { t } = useTranslation('settings');
  return <div className="flex h-64 items-center justify-center text-muted-foreground">{t('common.comingSoon')}</div>;
}
